import { makeObservable, observable, flow, computed } from "mobx";

import { api } from "@/lib/services";
import { ApiRoutes } from "@/lib/routes";

import BrowseControlActivitiesSummarySchema from "@/areas/compliance/schemas/BrowseControlActivitiesSummarySchema";
import { ComplianceConstants } from "./ComplianceConstants";

export default class BrowseControlActivitiesSummaryStore {
  loading = true;
  query = { search: "", page: 1 };
  summary = {};

  constructor(parentStore) {
    makeObservable(this, {
      loading: observable,
      summary: observable,
      actions: computed,
      load: flow,
    });

    this.parentStore = parentStore;
  }

  get actions() {
    const list = [];

    return list;
  }

  *load(query, options) {
    const parseResult = BrowseControlActivitiesSummarySchema.safeParse(query);

    if (!parseResult.success) {
      console.error(parseResult.error);
      return parseResult;
    }
    try {
      this.loading = true;

      const existingQuery = query.query;

      const storedRegistry = JSON.parse(localStorage.getItem(ComplianceConstants.StateKeys.ControlRegistries)) ?? [];
      const storedRegistryIds = storedRegistry.map((x) => x.id);
      const updatedQuery = { ...existingQuery, registry: { id: storedRegistryIds } };

      const response = yield api.post(ApiRoutes.forControlActivitiesSummary(query.controlId), query);
      this.summary = response.data;

      return { success: true, data: response.data };
    } catch (e) {
      return { success: false, error: e };
    } finally {
      this.loading = false;
    }
  }
}
